module.exports = __webpack_public_path__ + "img/bg_avatar_female_27.c8e01feb.png";